const funcitonModule = {
  namespaced: true, //开启命名空间
  state: () => ({
    // 页面调用this.$store.state.funciton.dataFilter
    filter: (val, that, field = "allCustomers", fieldKeep = "keep") => {
      if (val) {
        //val存在筛选数组
        that[field] = that[fieldKeep].filter((el) => {
          let re = new RegExp(val, 'i')
          return re.test(el[0]) || re.test(el[1])
        })
      } else {
        //val不存在还原数组
        that[field] = that[fieldKeep]
      }
    }
  }),
  mutations: {},
  actions: {},
  getters: {},
};
export default funcitonModule;



// WEBPACK FOOTER //
// ./src/store/modules/function.js